var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1739 4.81189C19.7026 4.28332 19.9997 3.56636 19.9998 2.81875C19.9999 2.07113 19.703 1.3541 19.1744 0.825393C18.6459 0.296684 17.9289 -0.000394485 17.1813 -0.000488259C16.4337 -0.000582033 15.7166 0.296316 15.1879 0.824893L1.84193 14.1739C1.60975 14.4054 1.43805 14.6904 1.34193 15.0039L0.0209344 19.3559C-0.00491027 19.4424 -0.00686216 19.5342 0.0152856 19.6217C0.0374333 19.7092 0.0828547 19.7891 0.146731 19.8529C0.210607 19.9167 0.290555 19.962 0.378093 19.984C0.465631 20.006 0.557494 20.0039 0.643935 19.9779L4.99693 18.6579C5.3101 18.5626 5.59511 18.392 5.82693 18.1609L19.1739 4.81189Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.72c44e83bb8afaafe29e720b86385d5c.svg";
export { ForwardRef as ReactComponent };